<template>
  <div class="detail">
    <!-- <navigation :tabs="tabs" @input="onChangeTab" :theme="theme" :defaultTabWidth="'20'">
      <div v-for="(tab, index) in tabs" :key="index" :slot="'tab'+index" class="tab">
        {{tab.name}}
      </div>
    </navigation> -->
    <p class="no-date" v-show="noDate">暂无数据</p>
    <div class="content" v-show="!noDate">
      <div class="vue-swiper">
        <swiper :options="listSwiperOption" ref="listSwiper" :autoHeight="true">
          <swiper-slide v-for="(list,index) in report_date" class="swiper-slide-tab" :key="index">
            <p class="stock-name" :class="theme">{{list.date_description}}</p>
            <div class="list">
              <!-- 主要指报 -->
              <div v-for="(item, key) in report_list[list.date_value].data" :key="key">
                <div class="space" v-if="item.item_display == '大类' && key > 0"></div>
                <p class="dt-quota" :class="theme" v-if="item.item_display == '大类'" @click="toCourse(item)">{{(item.item_value ? item.item_value : '&nbsp;') | financePercision(item.item_precision, item.item_display)}}</p>
                <dl :class="theme" v-else @click="toCourse(item)">
                  <dd class="is_tongbi" :class="{'font-w': item.item_display != '小类'}">
                    <span>{{item.item_value | financePercision(item.item_precision)}}</span>
                    <span v-if="isTongBi">{{item.item_tongbi | financePercision('tongbi')}}</span>
                  </dd>
                </dl>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev" :class="theme"></div>
          <div class="swiper-button-next" slot="button-next" :class="theme"></div>
        </swiper>
      </div>
      <div class="stock-name-text" :class="theme">
        <div class="right" @click="isTongBi = !isTongBi">
          <span style="font-size:.13rem;color: #596E98;">指标</span>
          <div class="tongbi">
            <img :src="tongbiYes" v-if="isTongBi">
            <img :src="tongbiNo" v-else>
          </div>
          <span>同比</span>
        </div>
      </div>
      <div class="details-name">
        <div v-for="(item, key) in current_date.data" :key="key" class="item">
          <div class="space" v-if="item.item_display == '大类' && key > 0"></div>
          <p class="dt-quota" :class="theme" v-if="item.item_display == '大类'" @click="toCourse(item)">{{item.item_title}}</p>
          <dl :class="theme" v-else @click="toCourse(item)">
            <dd :class="[{'font-w': item.item_display == '中类'}, {'suojin': item.item_display == '缩进'}]">{{item.item_title | filtersTitle}}</dd>
          </dl>
        </div>
        <div class="report-date">公告日期:&nbsp;&nbsp;{{current_date.publish_date | filterPubilshDate}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import tongbiNo from '@/assets/icons/tongbi-no.png'
import tongbiYes from '@/assets/icons/tongbi-yes.png'
import allList from '@/assets/icons/all-list.png'

import 'swiper/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Navigation from '@/components/navigation.vue'

import date from '@/filters/date'
import financePercision from '@/filters/financePercision'

import {request} from '@/api/request'
export default {
  props: ['options'],
  // Navigation
  components: { swiper, swiperSlide },
  data() {
    const vm = this
    return {
      tongbiNo,
      tongbiYes,
      allList,
      theme: '',
      swiperIndex: 0,
      listSwiperOption: {
        autoplay: false,
        initialSlide: 0,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
        on: {
          slideChangeTransitionEnd: function() {
            vm.swiperIndex = this.activeIndex
            vm.current_date = vm.report_list[vm.report_date[vm.swiperIndex].date_value]
          }
        }
      },
      isTongBi: false,
      // allBtnName: '全部',
      tabs: [
        {name: '全部', key: 0},
        {name: '年报', key: 4},
        {name: '半年报', key: 2},
        {name: '三季报', key: 3},
        {name: '一季报', key: 1},
      ],
      pageTypes: {
        'gjzb': '关键指标',
        'lrb': '利润表',
        'fzb': '负债表',
        'llb': '流量表'
      },
      allData: {},
      report_date: [],
      report_list: {},
      current_date: [],
      noDate: false
    }
  },
  computed: {
    // title () {
    //   const {market, symbol, stockname} = this.options
    //   return `${stockname} ${market.toUpperCase()}${symbol}`
    // },
    params () {
      const {market, symbol, financetType} = this.options
      return {
        market,
        code: symbol,
        type: financetType
      }
    },
    period () {
      return this.options.key
    }
  },
  filters: {
    financePercision,
    filterPubilshDate (val){
      return val ? (val.slice(0,4) + '-' + val.slice(4,6) + '-' + val.slice(6)) : '--'
    },
    filtersTitle(val){
      if(val){
        return val.length > 20 ? val.substring(0, 20) + '...' : val
      }
    }
  },
  watch: {
    options: {
      immediate: true,
      handler() {
        this.swiperIndex = 0
        this.init()
      }
    }
  },
  methods: {
    toCourse(){},
    async onChangeTab (index) {
      this.noDate = false
      this.formatAllData()
    },
    formatAllData () {
      let type = this.period
      //数据变动初始swiper activeIndex
      this.$refs.listSwiper.swiper.slideTo(0, 0, true);
      let report_date = [], report_list = {};
      this.allData.report_date.forEach(e => {
        if (type) {
          if (e.date_type == type) {
            report_date.push(e)
            report_list[e.date_value] = this.allData.report_list[e.date_value]
          }
        } else {
          report_date.push(e)
          report_list[e.date_value] = this.allData.report_list[e.date_value]
        }
      });
      if(report_date.length === 0) this.noDate = true
      this.report_date = report_date
      this.report_list = report_list
      this.current_date = report_list[report_date[this.swiperIndex].date_value]
    },
    async init(){
      console.log(this.options)
      this.allData = await request.get({
        url: request.apis.quote.hsFinance,
        params: this.params
      })
      console.log('-----', this.allData)
      if(!this.allData.report_date) return
      this.formatAllData()
    }
  }
}
</script>

<style lang="stylus" scoped>
padding-rl = .15rem

.detail {
  width: 100vw;
  min-height: 100vh;
  background-color: #ffffff;
  font-family: PingFangSC-Regular;
  color: #262D40;
  font-size: .15rem;
}

.first-title {
  width: 100%;
  padding: .11rem padding-rl .09rem padding-rl;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #F5F6FA;
}
.name {
  font-size: .2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #262D40;
}
.right{
  font-size: .12rem;
  font-weight: 400;
  font-family:PingFangSC-Regular;
  color: #98A0B3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.second-title {
  padding: 0 padding-rl;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #F5F6FA;
}
.name-second{
  font-size: .16rem;
}
.number-red {
  color: #E63535;  
}
.number-first {
  font-family: SFProText-Regular;
  margin: 0 .1rem .14rem .3rem;
  color: #E63535; 
}
.tongbi
  width: 14px;
  height: 14px;
  margin: 0 .06rem 0 .12rem;
  img 
    width 100%
    height 100%

.content {
  position: relative;
}

.content.dark {
  background: #161825;
}

.stock-name-text {
  line-height: .18rem;
  font-size: .13rem;
  color: #596E98;
  padding: .16rem .15rem;
  background-color: #F5F6FA;
  width: 2.1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stock-name {
  line-height: .18rem;
  font-size: .13rem;
  color: #596E98;
  text-align: center;
  padding: .16rem 0;
  padding-right: .14rem;
  padding-left: 0.6rem;
}

.details-name {
  width: 100%;
}

dl {
  background: white;
  margin: 0;
}

dd {
  width: 50%;
  height: .44rem;
  padding: 0 .15rem;
  font-size: .14rem;
  color: #262D40;
  margin: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
dd.two-line {
  height: .47rem;
}

dd.is_tongbi{
  padding-left: 0;
  display: flex;
  justify-content: space-between;
  span {
    flex: 1;
  }
}
.font-w{
  font-family: PingFangSC-Medium;
  font-weight: 700;
}

.vue-swiper dd {
  width: 100%;  
}
.dt-quota {
  font-size: .15rem;
  height: .41rem;
  line-height: .41rem;
  font-family:PingFangSC-Medium;
  font-weight: 700;
  background: #ffffff;
  color: #262D40;
  padding: 0rem .15rem;
  padding-right: 0;
  position: relative;
}
.space{
  width: 100%;
  height: .06rem;
  background-color: #F5F6FA;
}
.highlight {
  color: #E63535;
}

.asset, .debt {
  background: #ffffff;
  color: #262D40;
  padding: .1rem .15rem;
  font-size: .18rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}

.total {
  border-top: .25px solid border-color;
  padding: .1rem .15rem;
  background: white;
  line-height: 1.55;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}

.vue-swiper {
  position: absolute;
  width: 50%;
  right: 0;
  top: 0;
  text-align: right;
  font-size: font-xl;
  z-index: 2;

  .list {
    padding-right 0.15rem
  }

  .swiper-container {
    p, dl, .dt, dd {
      background: none;
    }
  }
}

.swiper-button-prev,
.swiper-button-next { 
  position: absolute;
  top: 0;
  width:  0.09rem;
  height: 0.14rem;
  margin-top: 0.18rem;
  z-index: 10;
  cursor: pointer;
  background-size: 0.22rem 0.22rem;
  background-position: center;
  background-repeat: no-repeat;
  outline: none;
  border: none;
}
.swiper-button-prev:after, .swiper-button-next:after{
  content: ''
}
.swiper-button-prev {
  left: 0.6rem !important;
  right: auto;
}
.swiper-button-next {
  right: .14rem;
  left: auto;
}

.swiper-button-next {
  background: url("../../../../../assets/icons/arrow-right.png") no-repeat center / 100%;
}

.swiper-button-prev {
  left: 0;
  right: auto;
}

.swiper-button-prev {
  background: url("../../../../../assets/icons/arrow-left.png") no-repeat center / 100%;
}

.mg-l {
  padding-left: 0.45rem;
}

.total-s {
  display: block;
  padding-top: padding-sm;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.6;
}

.report-date{
  height: .47rem;
  line-height: .47rem;
  text-align: left;
  padding: 0 .15rem;
  background-color: #F5F6FA;
}

.tab {
  line-height: .34rem;
}

.no-date
  padding-top .5rem
  text-align center

</style>